<div class="identi-page-wrapper pb-5">
  <app-product-hero
    [level]="productLevels.Level2"
    title="{{ plan2Name }}"
    secondarySubtitle="{{ secondarySubtitle }}"
    badgeUri="/assets/images/identibase/identiAlert/hero-badge-12.svg"
    (onBuyClick)="isBrandPetlog ? buyIdentialertAnnualSubscription() : buyIdentiAlertSubscription()"
    [compareVisible]="buyButtonVisible"
    [levelsVisible]="true"
    (onCompareClick)="compareClick()"
    [disabled]="!hasIdentiAlertOption && isAuthenticated"
    [buyHidden]="!buyButtonVisible"
  ></app-product-hero>

  <div class="row py-4 light-background">
    <div class="col-12 text-center px-3">
      <div class="row row-cols-lg-5 row-cols-md-5 row-cols-2 mt-1 px-lg-5 px-md-3 px-sm-1 d-flex justify-content-center">
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/identiAlert/care-icon.svg"
            alt="care-icon"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2" [innerHTML]="plan2FeatureText1"></h6>
        </div>
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/identiAlert/alert-badge.svg"
            alt="alert-badge"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2" [innerHTML]="plan2FeatureText2"></h6>
        </div>
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/identiAlert/sms-alert-badge.svg"
            alt="sms-alert-badge"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2" [innerHTML]="plan2FeatureText3"></h6>
        </div>
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/identiAlert/box-approved.svg"
            alt="box-approved"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2" [innerHTML]="plan2FeatureText4"></h6>
        </div>
      </div>
      <button
        *ngIf="buyButtonVisible"
        (click)="isBrandPetlog ? buyIdentialertAnnualSubscription() : buyIdentiAlertSubscription()"
        type="button"
        class="btn blue-button mt-lg-4 mt-md-3 mt-sm-2"
        [disabled]="!hasIdentiAlertOption && isAuthenticated"
      >
        Buy now
      </button>
    </div>
  </div>
  <div *appFeatureFlag="'isTrustpilotAvailable'" class="container">
    <div class="trustpilot-section">
      <div class="trustpilot-section-desktop">
        <app-trustbox-testimonials-desktop></app-trustbox-testimonials-desktop>
      </div>
      <div class="trustpilot-section-mobile">
        <app-trustbox-testimonials-mobile></app-trustbox-testimonials-mobile>
      </div>
    </div>
  </div>
  
  <div class="d-none d-md-block">
    <app-subscription-table-desktop
      id="subscription-table"
      [identibasePlusButtonLabel]="'Learn more'"
      [identialertButtonLabel]="'Buy now'"
      [alertHighlighted]="true"
      [buyButtonVisible]="buyButtonVisible"
      [buyButtonDisabled]="!hasIdentiAlertOption && isAuthenticated"
      (identitableButtonClicked)="onIdentitableButtonClicked($event)"
    ></app-subscription-table-desktop>
  </div>
  <div class="d-block d-md-none">
    <app-subscription-table-mobile
      id="subscription-table"
      [identibasePlusButtonLabel]="'Learn more'"
      [identialertButtonLabel]="'Buy now'"
      [alertHighlighted]="true"
      [buyButtonVisible]="buyButtonVisible"
      [buyButtonDisabled]="!hasIdentiAlertOption && isAuthenticated"
      (identitableButtonClicked)="onIdentitableButtonClicked($event)"
    ></app-subscription-table-mobile>
  </div>
</div>
